export default __webpack_public_path__ + "static/media/complexLasalle.30acc217.png";